/* Display-only enhancement: never sets variant IDs, app values, prices or validity. */
(() => {
  if (window.nxtCustomCleanupLoaded) return;
  window.nxtCustomCleanupLoaded = true;
  let fieldSequence = 0;
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  function initGuides(root = document) {
    root.querySelectorAll('[data-nxt-guide-open]').forEach(button => {
      const dialog = document.getElementById(button.dataset.nxtGuideOpen);
      if (!dialog || typeof dialog.showModal !== 'function' || button.dataset.nxtGuideReady) return;
      button.hidden = false;
      button.dataset.nxtGuideReady = 'true';
      button.addEventListener('click', () => {
        if (dialog.open) return;
        dialog.showModal();
        dialog.querySelector('[data-nxt-guide-close]')?.focus();
      });
      dialog.querySelector('[data-nxt-guide-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { if (button.isConnected) button.focus(); });
    });
  }
  function initCustom(marker) {
    const section = marker.closest('.shopify-section');
    if (!section || section.dataset.nxtCustomReady) return;
    section.dataset.nxtCustomReady = 'true';
    section.classList.add('nxt-custom-purchase');
    let pending = false;
    const enhance = () => {
      pending = false;
      const currentMarker = section.querySelector('[data-nxt-custom-summary]');
      if (!currentMarker) return;
      const copy = currentMarker.dataset;
      initGuides(section);
      // Class prefixes are stable app classes observed on the actual product DOM.
      section.querySelectorAll('.easify-product-options .po-option-root').forEach(option => {
        const field = option.querySelector('textarea, input[type="text"]');
        const label = option.querySelector('.po-label-label');
        if (field && label && !field.labels?.length && !field.getAttribute('aria-label') && !field.getAttribute('aria-labelledby')) {
          if (!field.id) field.id = `nxt-custom-field-${++fieldSequence}`;
          label.htmlFor = field.id;
        }
      });
      const appOptions = section.querySelector('.easify-product-options .po-options-root');
      const insertHeading = (before, kind, text) => {
        if (!before || !text) return;
        let heading = before.previousElementSibling;
        if (!heading?.matches(`[data-nxt-app-heading="${kind}"]`)) {
          heading = document.createElement('h2');
          heading.className = 'nxt-custom-step nxt-custom-step--app';
          heading.dataset.nxtAppHeading = kind;
          before.before(heading);
        }
        setText(heading, text);
      };
      insertHeading(appOptions?.querySelector('.po-option-root'), 'design', copy.designHeading);
      const proof = [...(appOptions?.querySelectorAll('.po-option-root') || [])].find(option =>
        [...option.querySelectorAll('.po-optionItemLabel-label')].some(label => /send me a proof/i.test(label.textContent)));
      insertHeading(proof, 'proof', copy.proofHeading);
      const picker = section.querySelector('variant-picker[ref="mainVariantPicker"]');
      const sizeSet = [...(picker?.querySelectorAll('fieldset') || [])].find(set =>
        /^size\b/i.test(set.querySelector('legend')?.textContent.trim() || ''));
      if (sizeSet) {
        let previousGroup = '';
        sizeSet.querySelectorAll('.variant-option__button-label').forEach(label => {
          const input = label.querySelector('input');
          if (!input) return;
          const group = /youth/i.test(input.value) ? 'Youth' : 'Adult';
          if (group !== previousGroup) {
            let heading = label.previousElementSibling;
            if (!heading?.matches('[data-nxt-size-group]')) {
              heading = document.createElement('span');
              heading.className = 'nxt-size-group';
              heading.dataset.nxtSizeGroup = group;
              label.before(heading);
            }
            setText(heading, `${group} sizes`);
          }
          previousGroup = group;
        });
        let help = picker.querySelector('[data-nxt-youth-help]');
        if (!help) {
          help = document.createElement('p');
          help.dataset.nxtYouthHelp = '';
          help.className = 'nxt-youth-help';
          help.setAttribute('role', 'status');
          picker.append(help);
        }
        const youth = /youth/i.test(sizeSet.querySelector('input:checked')?.value || '');
        help.hidden = !youth;
        setText(help, youth ? copy.youthHelp : '');
      }
      const form = section.querySelector('product-form-component form[action*="/cart/add"]');
      if (!form) return;
      const buttons = form.querySelector('.product-form-buttons');
      if (!buttons) return;
      // Easify mounts as a sibling before the form asynchronously. Keep our
      // non-control content inside the native form, directly before its buttons.
      // Reuse the existing recap after app mounts or variant form replacement.
      let recap = section.querySelector('[data-nxt-selection-summary]');
      if (!recap) {
        recap = document.createElement('div');
        recap.dataset.nxtSelectionSummary = '';
        recap.className = 'nxt-selection-summary';
        const title = document.createElement('h2');
        const choices = document.createElement('p');
        const price = document.createElement('p');
        recap.append(title, choices, price);
      }
      section.querySelectorAll('[data-nxt-selection-summary]').forEach(other => {
        if (other !== recap) other.remove();
      });
      if (recap.parentElement !== form || recap.nextElementSibling !== buttons) buttons.before(recap);
      const selected = [...(picker?.querySelectorAll('input:checked, select') || [])].map(input => input.value);
      const quantity = form.querySelector('[name="quantity"]')?.value || '1';
      const placement = appOptions?.querySelector('input[name="properties[Design placement]"]')?.value;
      const proofChoice = proof?.querySelector('input:checked');
      const proofLabel = proofChoice?.closest('label')?.querySelector('.po-optionItemLabel-label')?.textContent.trim();
      const choicesText = [...selected, placement, proofLabel, `Quantity: ${quantity}`].filter(Boolean).join(' · ');
      const priceText = section.querySelector('product-price .price')?.textContent.trim();
      setText(recap.children[0], copy.reviewHeading);
      setText(recap.children[1], choicesText);
      // The app remains the authority for supplements; no independent price arithmetic.
      setText(recap.children[2], priceText ? `Current displayed price: ${priceText}. Any option charges are confirmed in your cart.` : 'Your selected options and any additional charges are confirmed in your cart.');
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(enhance); } };
    section.addEventListener('change', schedule);
    section.addEventListener('input', schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(section, {childList: true, subtree: true, characterData: true});
    enhance();
  }
  function boot(root = document) {
    initGuides(root);
    root.querySelectorAll('[data-nxt-custom-summary]').forEach(initCustom);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('variant:update', () => initGuides());
})();
